import React from "react";
//import Ads from "../../ad-config";
import { Bling as GPT } from "react-gpt";
  
GPT.enableSingleRequest();
export default class ROS_Middle_Center_728_90 extends React.Component {
  render() {
    let Ads =this.props.AdData;
    return (
         <>       
      {(() => {
        if (Object.keys(this.props.AdData).length> 0 ) {
          return (
            <GPT
                  adUnitPath={Ads.adunitPath_rosMiddleCenter72890}
                  
                  name={Ads.name_rosMiddleCenter72890}
                   slotSize={[728, 90]}
      />
          )
        } 
      })()}
      </>
    );
  }
}
